import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGuangzhoumetroComponent } from './simple-icons-guangzhoumetro.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGuangzhoumetroComponent ],
    exports:      [ SimpleIconsGuangzhoumetroComponent ],
    bootstrap:    []
})
export class SimpleIconsGuangzhoumetroModule {}
